export default __webpack_public_path__ + "static/media/cyberpunkLogo.f28d0d8a.webp";